import { ObstetricalResourcesAnxietyScreening } from "@/Patient/Models/ObstetricalFile/Resources/ObstetricalResourcesAnxietyScreening";
import { BaseObstetricalFileSubSection, BaseObstetricalFileSubSectionProps } from "../../../Subcomponent/BaseObstetricalFileSubSection";
import { Gad7FormPopup } from "./Gad7FormPopup";
import { ObstetricalFileResourcesQuestionnaireTable } from "./ObstetricalFileResourcesQuestionnaireTable";

interface ObstetricalResourcesAnxietyScreeningSectionProps<TForm> extends BaseObstetricalFileSubSectionProps<TForm> {
    model: ObstetricalResourcesAnxietyScreening;
    mutateAnxietyScreeningStateWithFormUpdate: (mutation: (state: ObstetricalResourcesAnxietyScreening) => void, then?: () => void) => void;
    encounterId: string;
    patientContactFacetId: string;
    consultationDate: Date;
}

class ObstetricalResourcesAnxietyScreeningSectionState {
    public shouldShowGad7FormPopup: boolean;
    public isGad7PopupAnswered: boolean;
}

class ObstetricalResourcesAnxietyScreeningSection<TForm> extends BaseObstetricalFileSubSection<TForm, ObstetricalResourcesAnxietyScreeningSectionProps<TForm>, ObstetricalResourcesAnxietyScreeningSectionState> {
    public constructor(props: ObstetricalResourcesAnxietyScreeningSectionProps<TForm>) {
        super(props);
        this.state = new ObstetricalResourcesAnxietyScreeningSectionState();
    }

    public render(): JSX.Element {
        const anxietyScreening = this.props.model;

        return (
            <div>
                <ObstetricalFileResourcesQuestionnaireTable
                    id="AnxietyScreeningQuestionnaire"
                    title="AnxietyScreeningLabel"
                    subTitle="GeneralizedAnxietyDisorderScaleLabel"
                    subTitleClassName="text-bold"
                    readonly={this.props.readonly}
                    date={anxietyScreening.AnxietyScreeningDate}
                    onDateChange={date => this.props.mutateAnxietyScreeningStateWithFormUpdate(s => s.AnxietyScreeningDate = date)}
                    columns={[
                        { label: "NotAtAllLabel", pointValue: 0 },
                        { label: "SeveralDaysLabel", pointValue: 1 },
                        { label: "MoreThanHalfTheDaysLabel", pointValue: 2 },
                        { label: "NearlyEveryDayLabel", pointValue: 3 }
                    ]}
                    questions={[
                        {
                            questionLabel: "FeelingNervousAnxiousOrOnEdgeLabel",
                            onClick: value => this.mutateAnxietyScreeningStateWithFormUpdate(s => s.NervousScore = value),
                            value: anxietyScreening.NervousScore
                        },
                        {
                            questionLabel: "NotBeenAbleToStopOrControlWorryingLabel",
                            onClick: value => this.mutateAnxietyScreeningStateWithFormUpdate(s => s.WorryScore = value),
                            value: anxietyScreening.WorryScore
                        }
                    ]}
                    totalScore={anxietyScreening.TotalScore}
                    scoreDescription={{
                        titleLabel: "ObstetricalFile_TotalScoreOfThreeOrMoreWarrantsConsiderationLabel",
                        descriptionLabel: "ObstetricalFile_UsingGAD7ForFurtherAssessmentOrAdditionalMentalHealthFollowUpLabel"
                    }}
                />
                {this.state.shouldShowGad7FormPopup && !this.state.isGad7PopupAnswered && (
                    <Gad7FormPopup
                        onClose={() => this.mutateState(s => {
                            s.shouldShowGad7FormPopup = false;
                            s.isGad7PopupAnswered = true;
                        })}
                        encounterId={this.props.encounterId}
                        patientContactFacetId={this.props.patientContactFacetId}
                        consultationDate={this.props.consultationDate}
                    />
                )}
            </div>
        );
    }

    private mutateAnxietyScreeningStateWithFormUpdate(mutation: (state: ObstetricalResourcesAnxietyScreening) => void): void {
        this.props.mutateAnxietyScreeningStateWithFormUpdate(
            s => mutation(s),
            () => {
                if (this.props.model?.TotalScore >= 3)
                    this.mutateState(s => s.shouldShowGad7FormPopup = true);
            }
        );
    }
}

export { ObstetricalResourcesAnxietyScreeningSection, ObstetricalResourcesAnxietyScreeningSectionProps, ObstetricalResourcesAnxietyScreeningSectionState };
